import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { packageTransportFormDefault } from "@factory/form/form.default";
import { PackageTransportFormRule, PackageTransportFormSchema } from "@factory/form/form.rule";
import { useQyCreatePackageTransport } from "@factory/query/package-transport.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewPackageTransport() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreatePackageTransport } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New PackageTransport is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addPackageTransport, isLoading: isCreating } =
    useQyCreatePackageTransport(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<PackageTransportFormSchema>({
    defaultValues: packageTransportFormDefault,
    resolver: zodResolver(PackageTransportFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: PackageTransportFormSchema) => {
    const formData = mapCreatePackageTransport(form);
    addPackageTransport(formData);
  };
  const handleValidateError = (err: FieldErrors<PackageTransportFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
